import React from "react";

import images from "../../assets/images";
import "./style.css";

const Mesa = () => {
  const { liverpoolLogo } = images.mesa;
  const mesaUrl = "https://mesaderegalos.liverpool.com.mx/milistaderegalos/51994826";

  return (
    <section id="mesa">
      <div className="container">

        <div className="mesa-header" data-aos="fade-up">
          <img
            className="mesa-icon sink-on-hover"
            src="https://img.icons8.com/dotty/80/000000/gift.png"
            alt="regalo"
          />
          <h2 className="mesa-title">Mesa de Regalos</h2>
          <div className="mesa-rule"></div>
          <p className="mesa-subtitle">
            Lo más valioso para nosotros es compartir este día contigo<br />
            Si deseas hacernos un obsequio, encontrarás aquí nuestra mesa de regalos.
          </p>
        </div>

        <div className="mesa-card" data-aos="fade-up" data-aos-delay="100">
          <a href={mesaUrl} target="_blank" rel="noreferrer">
            <img
              className="mesa-liverpool-logo sink-on-hover"
              src={liverpoolLogo}
              alt="Liverpool"
            />
          </a>

          <div className="mesa-rule mesa-rule--short"></div>

          <p className="mesa-event-label">Número de Evento</p>
          <p className="mesa-event-number">51994826</p>

          <a
            className="mesa-button shrink-on-hover-button"
            href={mesaUrl}
            target="_blank"
            rel="noreferrer"
            role="button"
          >
            Ir a la Mesa de Regalos
          </a>
        </div>

      </div>
    </section>
  );
};

export default Mesa;
